const cache = new Map()
const CACHE_DURATION = 10 * 60 * 1000 // 10 minutes

export const getCached = (key) => {
  const entry = cache.get(key)
  if (!entry) return null
  if (Date.now() - entry.timestamp > CACHE_DURATION) {
    cache.delete(key)
    return null
  }
  return entry.data
}

export const setCached = (key, data) => {
  cache.set(key, { data, timestamp: Date.now() })
}

// ── localStorage-backed cache (for data that should survive page reloads) ──

export const getLSCached = (key, maxAgeMs) => {
  try {
    const raw = localStorage.getItem(`tmdb_ls_${key}`)
    if (!raw) return null
    const { data, timestamp } = JSON.parse(raw)
    if (Date.now() - timestamp > maxAgeMs) {
      localStorage.removeItem(`tmdb_ls_${key}`)
      return null
    }
    return data
  } catch {
    return null
  }
}

export const setLSCached = (key, data) => {
  try {
    localStorage.setItem(`tmdb_ls_${key}`, JSON.stringify({ data, timestamp: Date.now() }))
  } catch {
    // Ignore — storage quota or private-browsing restrictions
  }
}
